import React, { FC, useState } from "react";
import styled from "styled-components";

import { Popup } from "../common/Popup";
import { JsonSchemaForm } from "../JsonSchemaForm";
import { Label } from "../JsonSchemaForm/Label";
import { ListButton } from "../JsonSchemaForm/ListButton";
import { JsonSchema, ServiceParameters } from "../JsonSchemaForm/types";

export interface IModuleConfigurationSchemaFormProps {
    schema: JsonSchema;
    initialParams: string | undefined;
    title?: string;
    children?: React.ReactNode;
    onConfigurationChange: (config: string) => void;
}

export const ModuleConfigurationSchemaForm: FC<
    IModuleConfigurationSchemaFormProps
> = (props: IModuleConfigurationSchemaFormProps) => {
    const { schema, onConfigurationChange, initialParams, children } = props;
    const currentState = initialParams ? JSON.parse(initialParams) : {};
    const [params, setParams] = useState<ServiceParameters>(currentState);
    const [currentPath, setCurrentPath] = useState<string[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);

    return (
        <Container>
            <ConfigurationLabel
                value="Custom configuration"
                description="Custom json configuration"
            />
            <ListButton
                onClick={() => setShowModal(!showModal)}
                icon="chevron-right"
            >
                Open Configuration
            </ListButton>
            <Popup visible={showModal} windowClassName="window">
                {children && children}
                <JsonSchemaForm
                    schema={schema}
                    params={params}
                    path={[]}
                    setParams={setParams}
                    currentPath={currentPath}
                    setCurrentPath={setCurrentPath}
                    onSave={(config: string) => {
                        onConfigurationChange(config);
                        setShowModal(false);
                    }}
                    onBackFromBase={() => setShowModal(!showModal)}
                />
            </Popup>
        </Container>
    );
};

const Container = styled.div`
    .window {
        width: 22.5rem;
        min-width: 22.5rem;
        min-height: 33.8125rem;
        height: 33.8125rem;
        padding: 0rem;
        margin: 0rem;
    }
`;

const ConfigurationLabel = styled(Label)`
    margin-top: 1.625rem;
`;
